var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item"},[_c('LenderBox',{attrs:{"id":_vm.id,"lender-type":_vm.lenderType,"content":_vm.content,"alternate-data-config":_vm.alternateDataConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }